import * as React from 'react';
import SimplePieChart from '../../common/Chart/SimplePieChart';

export const renderChart = (data) => {
    const key = Math.random().toString(36).substring(7);
    return (
        <div key={key} className="text-center">
            <SimplePieChart data={data} height={300} />
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/components/widget/inventory/listInventory/ChartHelper.tsx